import {LOCATION_CHANGE} from 'react-router-redux';
import produce from 'immer';
import {
    DRIP_CAMPAIGN_CHANGE,
    DRIP_CAMPAIGN_WIZARD_INITIALIZE,
    DRIP_CAMPAIGN_WIZARD_FETCH_MESSAGES,
    DRIP_CAMPAIGN_WIZARD_SET_MESSAGES,
    DRIP_CAMPAIGN_WIZARD_FETCH_GROUPS,
    DRIP_CAMPAIGN_WIZARD_SET_GROUPS,
    DRIP_CAMPAIGN_WIZARD_FETCH_SENDERS,
    DRIP_CAMPAIGN_WIZARD_SET_SENDERS,
    DRIP_CAMPAIGN_WIZARD_SAVE,
    DRIP_CAMPAIGN_WIZARD_SAVE_SUCCESS,
    DRIP_CAMPAIGN_WIZARD_SAVE_ERROR,
    DRIP_ENROLLMENT_FETCH,
    DRIP_ENROLLMENT_FETCHED
} from '../actions/actionTypes';
import {CHANGE} from 'redux-form/es/actionTypes';
import {CRUD_GET_ONE_SUCCESS} from 'react-admin';

const initialState = {
    dripCampaign: {
        id: null,
        name: '',
        subject: '',
        message: null,
        targetGroup: null,
        sender: null,  // NEW REQUIRED FIELD
        triggerType: 'contact_created',
        delayInHours: 24,
        isActive: true
    },
    wizard: {
        initialized: false,
        saving: false,
        messages: {
            loaded: false,
            loading: false,
            data: []
        },
        groups: {
            loaded: false,
            loading: false,
            data: []
        },
        senders: {  // NEW: Add senders to wizard state
            loaded: false,
            loading: false,
            data: []
        }
    },
    enrollments: {
        loaded: false,
        loading: false,
        data: []
    }
};

export default (state = initialState, {type, payload, meta, error}) => {
    switch (type) {
        case DRIP_CAMPAIGN_CHANGE:
            return produce(state, draft => {
                draft.dripCampaign[meta.field] = payload;
            });

        case DRIP_CAMPAIGN_WIZARD_INITIALIZE:
            return produce(state, draft => {
                draft.wizard.initialized = true;
                draft.wizard.messages.loading = true;
                draft.wizard.groups.loading = true;
                draft.wizard.senders.loading = true;  // Also fetch senders on initialize
                // Don't reset dripCampaign here as this is called by both Create and Edit
            });

        case DRIP_CAMPAIGN_WIZARD_FETCH_MESSAGES:
            return produce(state, draft => {
                draft.wizard.messages.loading = true;
                draft.wizard.messages.loaded = false;
            });

        case DRIP_CAMPAIGN_WIZARD_SET_MESSAGES:
            return produce(state, draft => {
                draft.wizard.messages.loading = false;
                draft.wizard.messages.loaded = true;
                draft.wizard.messages.data = payload;
            });

        case DRIP_CAMPAIGN_WIZARD_FETCH_GROUPS:
            return produce(state, draft => {
                draft.wizard.groups.loading = true;
                draft.wizard.groups.loaded = false;
            });

        case DRIP_CAMPAIGN_WIZARD_SET_GROUPS:
            return produce(state, draft => {
                draft.wizard.groups.loading = false;
                draft.wizard.groups.loaded = true;
                draft.wizard.groups.data = payload;
            });

        case DRIP_CAMPAIGN_WIZARD_FETCH_SENDERS:
            return produce(state, draft => {
                draft.wizard.senders.loading = true;
                draft.wizard.senders.loaded = false;
            });

        case DRIP_CAMPAIGN_WIZARD_SET_SENDERS:
            return produce(state, draft => {
                draft.wizard.senders.loading = false;
                draft.wizard.senders.loaded = true;
                draft.wizard.senders.data = payload;
            });

        case DRIP_CAMPAIGN_WIZARD_SAVE:
            return produce(state, draft => {
                draft.wizard.saving = true;
            });

        case DRIP_CAMPAIGN_WIZARD_SAVE_SUCCESS:
            return produce(state, draft => {
                draft.wizard.saving = false;
                // Reset drip campaign state to initial values after successful create
                // This prevents the previous campaign data from persisting when creating multiple campaigns
                // Both redux-form reset (in saga) AND state reset (here) are needed
                draft.dripCampaign = {...initialState.dripCampaign};
            });

        case DRIP_CAMPAIGN_WIZARD_SAVE_ERROR:
            return produce(state, draft => {
                draft.wizard.saving = false;
            });

        case DRIP_ENROLLMENT_FETCH:
            return produce(state, draft => {
                draft.enrollments.loading = true;
                draft.enrollments.loaded = false;
            });

        case DRIP_ENROLLMENT_FETCHED:
            return produce(state, draft => {
                draft.enrollments.loading = false;
                draft.enrollments.loaded = true;
                draft.enrollments.data = payload;
            });

        // Handle react-admin CRUD actions for edit mode
        case CRUD_GET_ONE_SUCCESS:
            if (meta && meta.resource === 'drip-campaigns') {
                return produce(state, draft => {
                    // Safe update - only update known fields to prevent state pollution
                    const allowedFields = ['id', 'name', 'subject', 'message', 'targetGroup', 'sender', 'triggerType', 'delayInHours', 'isActive'];
                    const data = payload.data || {};
                    allowedFields.forEach(field => {
                        if (data.hasOwnProperty(field)) {
                            draft.dripCampaign[field] = data[field];
                        }
                    });
                });
            }
            return state;

        // Reset state when navigating away
        case LOCATION_CHANGE:
            if (payload && payload.pathname && !payload.pathname.includes('drip-campaigns')) {
                return initialState;
            }
            return state;

        // Handle form changes from redux-form
        case CHANGE:
            if (meta && meta.form === 'record-form' && meta.field) {
                return produce(state, draft => {
                    draft.dripCampaign[meta.field] = payload;
                });
            }
            return state;

        default:
            return state;
    }
};